import { AlertProps } from "@mui/material";
import { useAppDispatch } from "../../redux";
import { hideFeedbackNotification, showFeedbackNotification } from "../../redux/reducers/feedbackNotification.reducer";

export const useNotification = () => {
	const dispatch = useAppDispatch();

	function notify(message: string, severity?: AlertProps["severity"]) {
		dispatch(showFeedbackNotification({ message, severity }));
	}

	function closeNotification() {
		dispatch(hideFeedbackNotification());
	}

	return { notify, closeNotification };
};
